import React, { useCallback, useState, useEffect } from 'react';
import { clickSecurityKeypadEventWeb, failEventWeb, findPincodeWeb } from 'common/appInterface';

const KeypadTest = (props) => {

  const callback = useCallback(() => {
      props.setMain(true);
  }, [props]);

  const [screenId, setScreenId] = useState("APPL10");
  const [screenName, setScreenName] = useState("카드비밀번호");
  const [keypadCode, setKeypadCode] = useState("2");
  const [length, setLength] = useState(4);
  const [returnKeypadPid, setReturnKeypadPid] = useState("");
  const [returnKeypadCode, setReturnKeypadCode] = useState("");
  const [returnEnteredValue, setReturnEnteredValue] = useState("");
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [typingKeypadCode, setTypingKeypadCode] = useState("");
  const [typingLength, setTypingLength] = useState("");

  // clickSecurityKeypadEvent_Web 처리 (WEB > APP)
  const clickSecurityKeypadEvent = useCallback(() => {
    clickSecurityKeypadEventWeb(screenId, screenName, keypadCode, length);
  }, [screenId, screenName, keypadCode, length]);

  // typingSecurityKeypad_App 처리 (APP > WEB)
  const typingSecurityKeypadApp = useCallback((event) => {
    setTypingKeypadCode(event.detail.keypadPid);
    setTypingLength(event.detail.length);
    alert("typingSecurityKeypad_App catch...");
  }, []);

  // completedSecurityKeypad_App 처리 (APP > WEB)
  const completedSecurityKeypadApp = useCallback((event) => {
    setReturnKeypadPid(event.detail.keypadPid);
    setReturnKeypadCode(event.detail.keypadCode);
    setReturnEnteredValue(event.detail.enteredValue);
    alert("completedSecurityKeypad_App catch...");
  }, []);

  // failEvent_Web 처리 (WEB > APP)
  const failEvent = useCallback(() => {
    failEventWeb(code, message);
  }, [code, message]);

  // findPincode_Web 처리 (WEB > APP)
  const findPincode = useCallback(() => {
    findPincodeWeb();
  }, []);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("backpress", callback);
    return () => document.removeEventListener("backpress", callback);
  }, [callback]);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("typingKeypad", typingSecurityKeypadApp);
    return () => document.removeEventListener("typingKeypad", typingSecurityKeypadApp);
  }, [typingSecurityKeypadApp]);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("completKeypad", completedSecurityKeypadApp);
    return () => document.removeEventListener("completKeypad", completedSecurityKeypadApp);
  }, [completedSecurityKeypadApp]);

  return (
    <div id="container">
      <section className="contents">
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">clickSecurityKeypadEvent_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxWrapTy01" style={{overflow: "initial"}}>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={screenId} onChange={(e) => setScreenId(e.target.value)} />
                  <span>screenId</span>
                </label>
              </div>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={screenName} onChange={(e) => setScreenName(e.target.value)} />
                  <span>screenName</span>
                </label>
              </div>
            </div>
            <div className="inputBoxWrapTy01" style={{overflow: "initial"}}>
              <div className="inputBoxTy01 formSelectBoxTy02">
                <label className="mgb20" style={{margin: "0 0 45px", position: "relative", display: "inline-block", width: "100%"}}>
                  <select style={{padding: "10px 0"}} value={keypadCode} onChange={(e) => setKeypadCode(e.target.value)}>
                    <option value="1">[1] 결제비밀번호(6자리)</option>
                    <option value="2">[2] 카드비밀번호(4자리)</option>
                    <option value="3">[3] 카드비밀번호(2자리)</option>
                    <option value="4">[4] CVC(3자리)</option>
                    <option value="5">[5] 카드비밀번호확인(4자리)</option>
                  </select>
                  <span style={{opacity: ".5", transform: "scale(0.75) translateY(-80%) translateX(0px)", transformOrigin: "left", padding: "10px 0", fontSize: "18px", pointerEvents: "none", position: "absolute", left: "0", top: "0", transition: "0.2s", transitionTimingFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)"}}>keypadCode</span>
                </label>
              </div>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="number" value={length} onChange={(e) => setLength(e.target.value)} />
                  <span>length</span>
                </label>
              </div>
            </div>
            <div className="btnWrapTy01">
              <button type="button" className="btnPrimaryTy01" onClick={clickSecurityKeypadEvent}><span>clickSecurityKeypadEvent_Web Call</span></button>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">typingSecurityKeypad_App</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxWrapTy01" style={{overflow: "initial"}}>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={typingKeypadCode} readOnly />
                  <span>keypadCode</span>
                </label>
              </div>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={typingLength} readOnly />
                  <span>length</span>
                </label>
              </div>
            </div>
          </div>
          <div className="btnWrapTy01">
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">completedSecurityKeypad_App</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={returnKeypadPid} readOnly />
                <span>keypadPid</span>
              </label>
            </div>
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={returnKeypadCode} readOnly />
                <span>keypadCode</span>
              </label>
            </div>
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={returnEnteredValue} readOnly />
                <span>enteredValue</span>
              </label>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">failEvent_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={code} onChange={(e) => setCode(e.target.value)} />
                <span>code</span>
              </label>
            </div>
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={message} onChange={(e) => setMessage(e.target.value)} />
                <span>message</span>
              </label>
            </div>
            <div className="btnWrapTy01">
              <button type="button" className="btnPrimaryTy01" onClick={failEvent}><span>failEvent_Web Call</span></button>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">findPincode_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="btnWrapTy01 mgb120">
              <button type="button" className="btnPrimaryTy01" onClick={findPincode}><span>findPincode_Web Call</span></button>
            </div>
          </div>
        </div>
      </section>
      <div className="btnArea">
        <div className="btnWrapTy01">
          <button type="button" className="btnPrimaryTy01 mgb60" onClick={callback}><span>메뉴복귀</span></button>
        </div>
      </div>
    </div>
  );
}

export default KeypadTest;